import { render, staticRenderFns } from "./ResidenceForm.vue?vue&type=template&id=d6330016&scoped=true&"
import script from "./ResidenceForm.vue?vue&type=script&lang=ts&"
export * from "./ResidenceForm.vue?vue&type=script&lang=ts&"
import style0 from "./ResidenceForm.vue?vue&type=style&index=0&id=d6330016&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6330016",
  null
  
)

export default component.exports